// extracted by mini-css-extract-plugin
export default {"loading":"preview_loading__IfQNc"};